<div class="col-lg-6 question-label">
    <label>{{label}}
        <span *ngIf="question?.required">*</span>
    </label>
</div>

<div class="col-lg-6">
    <p-select 
        [class.validate_error_cls]="isFormSubmitted && meAsControl?.invalid"
        [options]="question?.questionOptions"
        [(ngModel)]="value" 
        [name]="name ?? question?.name"
        [id]="id ?? question?.name"
        #dropdownCtrl="ngModel"
        [requiredAmtOrDecline] ="required"
        [placeholder]="waterMark" [disabled]="disabled"
        (onChange)="onDropdownChanged($event)">
    </p-select>
    <span class="validationred" *ngIf="isFormSubmitted && meAsControl?.invalid">
        {{ validationMessage ?? (meAsControl?.errors | json) }}
    </span>
</div>